import React, { PropsWithChildren, useCallback, useContext, useState } from 'react';
import { CustomText } from '@/components/CustomText';
import { ScrollView, ScrollViewProps, StyleProp, StyleSheet, useWindowDimensions, View, ViewStyle } from 'react-native';
import { Button, Text } from 'react95-native-rabbl';
import { CustomDivider } from "@/components/CustomDivider";
import { Link } from 'expo-router';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppConsts from '@/utilities/AppConsts';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { BasicScrollView } from "@/components/BasicScrollView";
import type { RootState } from '@/state/store';
import { useSelector, useDispatch } from 'react-redux';
import { setAgePassed } from '@/state/modals';
import { AppText } from '@/components/AppText';
import * as AgeRange from 'expo-age-range';

const styles = StyleSheet.create({
  modalContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 1000,
  },
  modalView: {
    backgroundColor: AppConsts.MAIN_COLOR2,
    padding: 20,
    gap: 20,
    borderWidth: 4,
    borderColor: AppConsts.COLOR7,
    alignItems: "center",
  },
  buttonsRow: {
    flexDirection: "row",
    gap: 20,
  },
  modalfyContainer: {
    backgroundColor: AppConsts.MAIN_COLOR2,
    padding: 20,
    gap: 20,
  },
});

interface Props {
};

export function AgeModalNative({ }: Props) : React.ReactNode {
  const dispatch = useDispatch();

  const {height : screenHeight, width : screenWidth} = useWindowDimensions();

  const onAgeCheck = useCallback(async () => {
    try {
      const ageAssuranceRegulationApplies = await AgeRange.isEligibleForAgeFeaturesAsync();
      if (ageAssuranceRegulationApplies) {
        // On Android, ask the user to share their age signals first. Resolves with null on iOS.
        const androidAgeRequest = await AgeRange.requestAgeSignalsAccessAsync();
        if (androidAgeRequest !== null && androidAgeRequest !== 'SHARED') {
          throw new Error("To use Rabbl, you must consent to sharing your age range.");
        }
        const ageRange = await AgeRange.requestAgeRangeAsync({
          threshold1: 18,
        });
        AppUtilities.info("LayoutRouting loadInitialData ageRange.lowerBound = " + ageRange.lowerBound);
        if (ageRange.lowerBound !== null && ageRange.lowerBound >= 18) {
          dispatch(setAgePassed(true));
        } else {
          AppUtils.showErrorToast('Error: Age range lower bound is ' + ageRange.lowerBound, null, true);
        }
      } else {
        dispatch(setAgePassed(true));
      }
    } catch (e) {
      AppUtilities.handleException(e, "AgeModalNative.onAgeCheck");
      AppUtils.showErrorToast('Error: ' + AppUtilities.getErrors(e), null, true);
    }
  }, [dispatch]);

  let maxWidth = AppConsts.BASIC_MINIMUM_WIDTH;
  if (screenWidth > (maxWidth * 2.5)) {
    maxWidth *= 2;
  }

  return (
    <View style={[styles.modalContainer, { width: screenWidth, height: screenHeight }]}>
      <View style={[styles.modalView, { maxWidth: maxWidth }]}>
        <CustomText>Sorry</CustomText>

        <AppText>You must be 18 years or older to use Rabbl.</AppText>

        <View style={styles.buttonsRow}>
          <Button onPress={onAgeCheck}>Try age check again</Button>
        </View>
      </View>
    </View>
  );
};
